import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { Formik } from 'formik';
import { isMobile } from 'react-device-detect';
import firebase from '../../../configs/environments/firebase/firebaseApp';
import { recoverPass } from '../components/extras/validation/schema';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import ArrowBackStandar from '../../../components/ArrowBack/ArrowBackStandar';
import Header from '../../../components/Headers/Header';
import Copyright from '../components/Copyright';
import FooterForm from '../components/Footer';
import './formRecoveryPassGeneric.scss';


const styles = () => ({
  colorGrayIcon: {
    color: '#c1c1c1',
    padding: 0
  },
  TextField: {
    maxWidth: '336px'
  }
});

class FormRecoverPassword extends Component {
  state = {
    showPassword: false,
    forgetPassword: false,
    open: false
  };


  onSubmit = (values, { setSubmitting, setErrors, setFieldError }) => {
    setSubmitting(false);
    const { confirmPassword, password } = values;
    
    if (confirmPassword === password) {
          const { password } = values;
          let str = window.location.href;
          const link = str.split('Code=').pop();
          let apiKey = link.indexOf('&apiKey');
          let code = link.substr(0, apiKey);

          firebase.auth().confirmPasswordReset(code, password)
            .then(res => {
              console.log('res', res);
              this.props.history.push('/')
            })
            .catch(error => {
              console.log('error', error);
              switch (error.code) {
                case 'auth/user-not-found':
                  return setErrors({ email: 'Esta cuenta no existe' });
                case 'auth/invalid-action-code':
                  return setErrors({ confirmPassword: 'El link ya expiró, solicite el cambio de nuevo' });
                case 'auth/wrong-password':
                  return setErrors({ password: 'La contraseña no o el usuario no es válido' });
                case 'auth/too-many-requests':
                  return setErrors({
                    password: 'Limite de intentos porfavor espere un momento'
                  });
                default:
                  return setErrors({ email: 'Ocurrió un error' });
              }
          })
        } else {
          setFieldError(
            'confirmPassword',
            'La nueva contraseña y su confirmación no coinciden'
          );
        }
};

  changeState = () => {
    this.setState({ open: false });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handlerBack = () => {
    this.props.history.push('/');
  };

  renderFormResetPassword = props => {
    const {
      values,
      handleChange,
      handleSubmit,
      touched,
      handleBlur,
      errors,
      isValid
    } = props;
    const { classes } = this.props;

    return (
      <>
        <Header />
        <div className="generic-container">
          <form className="container-box-generic">
            <div className="formRecoveryGeneric_header">
              <div className="formRecoveryGeneric_icons">
                <ArrowBackStandar
                  text=" regresar"
                />
                <figure className="formRecoveryGeneric_close">
                {isMobile ? (<img src="/img/icons/close.svg" alt="close" />) :''}
                </figure>
              </div>
              <figure className="formRecoveryGeneric_logo">
                <img src="/img/Logo-box.svg" alt="logo" />
              </figure>
              <p className="formRecoveryGeneric_title">Restablecer tu contraseña.</p>
            </div>
            <div className="formRecoveryGeneric_body">
              <p className="formRecoveryGeneric_text">
                Las contraseñas fuertes incluyen números, letras
              </p>
              <div>
                <div>
                  <TextField
                    label="Nueva Contraseña"
                    type="password"
                    id="password"
                    variant="outlined"
                    classes={{ root: classes.TextField }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={
                      touched.password && errors.password ? errors.password : ''
                    }
                    error={touched.password && errors.password ? true : false}
                  />
                </div>
                <div>
                  <TextField
                    label="Confirmar Contraseña"
                    type="password"
                    id="confirmPassword"
                    variant="outlined"
                    classes={{ root: classes.TextField }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirmPassword}
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                        ? errors.confirmPassword
                        : ''
                    }
                    error={
                      touched.confirmPassword && errors.confirmPassword
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              <div className="horizontalGeneric_layout_rec" >
                <ButtonBase
                  type="submit"
                  onClick={handleSubmit}
                  variant="primary"
                  disabled={!isValid}
                >
                  Enviar
                </ButtonBase>
              </div>
            </div>
            <div className="formRecoveryGeneric_footer">
              <FooterForm
                margin="8px 0px 16px"
                text="Si tienes cualquier duda o problema escribenos a:"
                textLink="hola@contactaabogado.com"
                linkTo=""
              />
            </div>
          </form >
        </div>
        <Copyright />
      </>
    );
  };

  render() {
    const incialValuesTwo = {
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    };

    return (
      <Formik
        initialValues={incialValuesTwo}
        validationSchema={recoverPass}
        onSubmit={this.onSubmit}
        render={this.renderFormResetPassword}
      />
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const ResetEmail = connect(mapStateToProps)(withStyles(styles)(FormRecoverPassword));

export default withRouter(ResetEmail);
